import React, { useEffect, useRef, useState } from 'react';
import { ASCENT_STOPS, IMAGES, TOKEN } from '../data/mock';
import { Fish, Anchor } from 'lucide-react';

export default function TheAscent() {
  const trackRef = useRef(null);
  const [progress, setProgress] = useState(0); // 0 (surface) → 1 (trench)

  useEffect(() => {
    const onScroll = () => {
      const el = trackRef.current;
      if (!el) return;
      const rect = el.getBoundingClientRect();
      const vh = window.innerHeight;
      // start progressing when track top enters bottom of viewport
      const total = rect.height + vh;
      const passed = Math.min(Math.max(vh - rect.top, 0), total);
      // We want 0 at the TOP of the track (paradise) and 1 at the bottom (trench)
      // Since first ASCENT_STOPS entry is Surface (top), progress increases as user scrolls DOWN
      const p = Math.max(0, Math.min(1, passed / total));
      setProgress(p);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <section id="l4" className="chapter ascent-chapter">
      <div className="ascent-bg">
        <div className="ascent-paradise-img" style={{ backgroundImage: `url(${IMAGES.reefParadise})` }} />
        <div className="ascent-paradise-fade" />
        <div className="ascent-gradient" />
        <div className="ascent-rays" />
        <div className="ascent-trench-glow" />
      </div>

      <div style={{ position: 'relative', zIndex: 3, width: '100%', maxWidth: 1200, margin: '0 auto' }}>
        <div className="chapter-eyebrow font-sans" style={{ margin: '0 auto 20px', justifyContent: 'center' }}>
          <span style={{ height: 1, width: 60, background: 'linear-gradient(to left, #f3c04a, transparent)' }} />
          LIFE IV &middot; THE ASCENT
          <span style={{ height: 1, width: 60, background: 'linear-gradient(to right, #f3c04a, transparent)' }} />
        </div>

        <h2 className="ascent-headline">
          From the deepest dark<br />
          to the <em>brightest reef.</em>
        </h2>
        <p className="ascent-lead">
          FISHE's roadmap isn't a slide deck — it's an ascent. Six zones, six milestones, one goldfish rising 10,984 meters against the current.
        </p>

        <div ref={trackRef} className="ascent-track">
          {/* Vertical spine */}
          <div className="ascent-spine">
            <div className="ascent-spine-fill" style={{ height: `${(1 - progress) * 100}%` }} />
            {/* Fish position marker along the spine (starts at trench = bottom when progress=0, rises as user scrolls) */}
            <div
              className="ascent-fish-marker"
              style={{ top: `${(1 - progress) * 100}%` }}
              aria-hidden
            >
              <img src={TOKEN.coinImage} alt="" />
            </div>
          </div>

          {/* Stops (rendered top→bottom: paradise first, trench last) */}
          <div className="ascent-stops">
            {ASCENT_STOPS.map((s, i) => (
              <div key={s.label} className={`ascent-stop tone-${s.tone} ${i % 2 === 0 ? 'right' : 'left'}`}>
                <div className="ascent-node">
                  {s.tone === 'trench' ? <Anchor size={14} /> : s.tone === 'paradise' ? <Fish size={14} /> : <span className="ascent-dot" />}
                </div>
                <div className="ascent-card">
                  <div className="ascent-depth font-mono">{s.depth}</div>
                  <div className="ascent-zone font-sans">{s.zone}</div>
                  <div className="ascent-label">{s.label}</div>
                  <p className="ascent-body font-sans">{s.body}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
